export const loyaltyProgramUrl = '/rewards'
